import { render, staticRenderFns } from "./MTitle.vue?vue&type=template&id=c783889a&scoped=true&"
import script from "./MTitle.vue?vue&type=script&lang=js&"
export * from "./MTitle.vue?vue&type=script&lang=js&"
import style0 from "./MTitle.vue?vue&type=style&index=0&id=c783889a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c783889a",
  null
  
)

export default component.exports